import moment from "moment";

export function handleDateAndTime(date) {
  return moment(date).format('D/M/YYYY • H:mm')
}
